import { createContext } from 'react'

type Props = {
  selectedGroup: number
  setSelectedGroup: (n: number) => void
  selectedGraph: number
  setSelectedGraph: (n: number) => void
}

export const GraphContext = createContext<Props>({
  selectedGroup: 0,
  selectedGraph: 0,
  setSelectedGraph() {
    console.error('You forgot to put the Accordion provider')
  },
  setSelectedGroup() {
    console.error('You forgot to put the Accordion provider')
  },
})
